<template>
  <CRUDDialog ref="crudDialog" :baseCrudKey="dialogCrudKey"
  dialogDynamicWidth="40vw"
  dialogHeaderName="Personal Tax Warrants Information"
  :canSave="true"   @upsertItem="upsertTransaction">
    <template v-slot:[`editedItem`]="{ }">
      <template class="">
        <div class="input-text-size pa-0 ma-0 custom-red-text">{{ errorMessage }}</div>
        <div v-if="ownerName" class="input-text-size pa-0 ma-0">
  <span class="font-weight-bold">Owner Name:</span> {{ ownerName || 'N/A' }}
</div>
            <div class="scrollable-ctnr pb-0 ma-0">
            <div class="input-text-size pa-0 ma-0 ">
              By Confirming, you will create  {{ warrantsToCreateCount }}
              new records in the Personal Tax Warrants system
            </div>
            <div class="input-text-size pa-0 ma-0 ptw-numbering-order">
              Warrants will be numbered in <span class="font-weight-bold">{{ numberingOrderLabel }}</span>
            </div>
            <!-- Years the county has flagged "Exclude from Personal Tax Warrants" on the
                 status code setup screen. Shown before anything is written: Tulsa only
                 found out a bankruptcy-discharged year had been warranted when the letter
                 came out of the printer with a warrant number against it. -->
            <v-alert v-if="excludedSelected.length" dense outlined type="warning"
              class="input-text-size ptw-excluded-selected mt-2 mb-2">
              <div class="font-weight-bold">
                {{ excludedSelected.length }} of the {{ selectedItems.length }} selected
                record(s) will NOT be warranted - excluded status code:
              </div>
              <div v-for="rec in excludedSelected" :key="`sel-${rec.taxYear}-${rec.taxId}`">
                {{ rec.taxYear }} &middot; TID {{ rec.taxId }}
                <span v-if="rec.propertyOrParcelId"> &middot; {{ rec.propertyOrParcelId }}</span>
                &mdash; {{ rec.excludedStatusCodeDescription }}
              </div>
            </v-alert>
            <v-alert v-if="excludedSiblings.length" dense outlined type="info"
              class="input-text-size ptw-excluded-siblings mt-2 mb-2">
              <div class="font-weight-bold">
                {{ excludedSiblings.length }} other year(s) on these parcels will be left
                off the warrants - excluded status code:
              </div>
              <div v-for="rec in excludedSiblings" :key="`sib-${rec.taxYear}-${rec.taxId}`">
                {{ rec.taxYear }} &middot; TID {{ rec.taxId }}
                <span v-if="rec.propertyOrParcelId"> &middot; {{ rec.propertyOrParcelId }}</span>
                &mdash; {{ rec.excludedStatusCodeDescription }}
              </div>
            </v-alert>
            <div class="input-text-size pa-0 ma-0 font-weight-bold text-h6 primary--text">
              Your beginning warrant number will be {{ editedItem.warrantNumber }}
            </div>
            <div class="input-text-size pa-0 mb-6 ">
              To each record will be applied the following fees:
            </div>
            <v-row class="">
              <v-col cols="6" class="pt-0 pb-0">
                  <v-text-field class='input-text-size pa-0 ma-0 ' readonly
                  v-model="editedItem.sherifFee">
                  <template v-slot:label>
                    <label>Sheriff Fee</label>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="6" class="pt-0 pb-0 ">
                  <v-text-field class='input-text-size pa-0 ma-0 '
                  v-model.number="editedItem.sherifFeeAmount"
                  @blur="amountToNum('sherifFeeAmount')">
                  <template v-slot:label>
                    <label>Sheriff Fee Amount</label>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="6" class="pt-0 pb-0">
                  <v-text-field class=' input-text-size pa-0 ma-0' readonly
                  v-model="editedItem.treasureFee">
                  <template v-slot:label>
                    <label>Treasurer Fee</label>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="6" class="pt-0 pb-0">
                  <v-text-field class=' input-text-size pa-0 ma-0'
                  v-model.number="editedItem.treasureFeeAmount"
                  @blur="amountToNum('treasureFeeAmount')">
                  <template v-slot:label>
                    <label>Treasurer Fee Amount</label>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          <v-row>
            <v-col cols='6' class="pt-0 pb-0 mt-n5">
                            <ClarionDateControl class="input-text-size"
                            :isToggle="false"
                            :isIsoDate="true"
                             v-model="editedItem.penaltyDate" label="Penalty Date" />
                        </v-col>
          </v-row>
          </div>

</template>

      </template>
  </CRUDDialog>

</template>

<script>
import {
  mapGetters, mapState, mapMutations, mapActions,
} from 'vuex';
import CRUDDialog from '../../../common/base/crud-2.0/CRUDDialog.vue';
import ClarionDateControl from '../../../common/ClarionDateControl.vue';
import { toIsoDate } from '../../../../util/shared/tmc-global';
import { clients } from '../../../../util/clients';
import { TaxWarrantsDialogMixin } from '../../warrants/utils/taxWarrants.mixin';
import {
  formatWarrantNumber,
  warrantAmountUtils,
  urlEncodeObject,
  resolveTrWorkFileSort,
  sortTrWorkFileRecords,
  describeTrWorkFileSort,
} from '../../warrants/utils/taxWarrants.util';

const { backendRest } = clients.direct;

export default {
  name: 'TaxWarrantsCreateDialogTRWork',
  mixins: [TaxWarrantsDialogMixin],
  components: {
    CRUDDialog,
    ClarionDateControl,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: '',
    },
    // The TR Work File grid's crud key - its criteria hold the sort the user is looking at.
    gridCrudKey: {
      type: String,
      default: 'browseListNames',
    },
  },
  data: () => ({
    dialogCrudKey: 'personalTaxWarrantCreate',
    errorMessage: null,
    // Records in (or alongside) the selection carrying a status code flagged
    // "Exclude from Personal Tax Warrants". Loaded when the dialog opens.
    excludedRecords: [],
  }),
  created() {
    this.loadConfig({ requiredScope: 'taxConfig' });
  },
  computed: {
    ...mapGetters('base/crud', ['item', 'isVisible', 'criteria']),
    ...mapState({
      nextWarrantNumber: (state) => state.tax.taxWarrants.nextWarrantNumber,
      nextWarrantSystemID: (state) => state.tax.taxWarrants.nextWarrantSystemID,
      StoreSelItems: (state) => state.tax.trWorkFile.selectedItems,
    }),

    editedItem: {
      get() {
        return this.item(this.dialogCrudKey);
      },
      set(value) {
        this.setItem([this.dialogCrudKey, value]);
      },
    },
    // The records are numbered in this order, so the first one is the owner the batch starts with.
    ownerName() {
      const [first] = this.sortedSelectedItems;
      if (first) {
        return `${first.name1 || ''}  ${first.name2 || ''}`;
      }
      return '';
    },
    gridSortBy() {
      return resolveTrWorkFileSort(this.criteria(this.gridCrudKey));
    },
    numberingOrderLabel() {
      return describeTrWorkFileSort(this.gridSortBy);
    },
    visibility() {
      return this.isVisible(this.dialogCrudKey);
    },
    selectedItems: {
      get() {
        return this.StoreSelItems;
      },
    },
    // selectedItems keeps the order the rows were checked in; numbering follows the grid's sort.
    sortedSelectedItems() {
      return sortTrWorkFileRecords(this.selectedItems, this.gridSortBy);
    },
    // Keyed the same way everywhere so "is this record excluded" is one lookup.
    excludedSelectedKeys() {
      return new Set(this.excludedRecords
        .filter((rec) => rec.isSelected)
        .map((rec) => `${rec.taxYear}-${rec.taxId}`));
    },
    excludedSelected() {
      return this.excludedRecords.filter((rec) => rec.isSelected);
    },
    excludedSiblings() {
      return this.excludedRecords.filter((rec) => !rec.isSelected);
    },
    warrantsToCreateCount() {
      return Math.max((this.selectedItems || []).length - this.excludedSelected.length, 0);
    },
  },
  watch: {
    visibility: {
      handler(visible) {
        if (visible && this.nextWarrantNumber !== null) {
          this.applyBeginningWarrantNumber(this.nextWarrantNumber);
          this.editedItem.systemId = this.nextWarrantSystemID;
        }
        if (visible) this.loadExcludedRecords();
        else this.excludedRecords = [];
      },
      immediate: true,
    },
    nextWarrantNumber(newValue) {
      if (this.visibility && newValue !== null) {
        this.applyBeginningWarrantNumber(newValue);
      }
    },
    // loadConfig() is async, so the current tax year can land after the dialog is already
    // open - fill in the beginning number that was held back when it did.
    currentWarrantTaxYear() {
      if (this.visibility && this.nextWarrantNumber !== null) {
        this.applyBeginningWarrantNumber(this.nextWarrantNumber);
      }
    },
  },
  methods: {
    ...mapMutations('base/crud', ['setItem']),
    ...mapActions(['flashError']),
    ...mapActions('tax/taxWarrants', [
      'upsertBulkTaxWarrant',
      'loadPtwExcludedTaxRecords',
    ]),
    ...mapActions('SystemConfig', [
      'loadConfig',
    ]),

    formatWarrantNumber(taxYear, warrantNumber) {
      return formatWarrantNumber(taxYear, warrantNumber);
    },

    // One place that builds the beginning number, so the prefix cannot drift between the
    // value previewed in the dialog and the one actually written at submit time.
    applyBeginningWarrantNumber(sequence) {
      if (!(this.selectedItems || []).length) return false;
      if (!this.currentWarrantTaxYear) return false;
      this.editedItem.warrantNumber = this.formatWarrantNumber(
        this.currentWarrantTaxYear, sequence,
      );
      return true;
    },

    // Ask which of the picked records (and which of their parcels' other years) carry a
    // status code flagged "Exclude from Personal Tax Warrants", so the dialog can say so
    // before the user confirms. A failure here returns [] and the dialog simply shows no
    // warning - the backend drops the same records regardless.
    async loadExcludedRecords() {
      const records = this.selectedItems || [];
      if (records.length === 0) {
        this.excludedRecords = [];
        return;
      }
      this.excludedRecords = await this.loadPtwExcludedTaxRecords({
        criteria: {
          taxIdYears: records.map((rec) => ({ taxYear: rec.taxYear, taxId: rec.taxId })),
          // Auto-add sweeps a parcel's whole delinquent history by baseId, so the years
          // the user never picked matter just as much as the ones they did.
          baseIds: [...new Set(records.map((rec) => rec.baseId).filter((id) => id !== undefined && id !== null))],
        },
      });
    },

    preProcessForUpsert(item) {
      const taxInquiryItems = [];
      // Excluded records are dropped HERE, before the numbers are handed out, so the batch
      // stays contiguous. (The backend drops them too - this just keeps 10 warrants
      // numbered 1-10 rather than 1-12 with two holes in it.)
      // The survivors are then put in the grid's sort order, because the selection holds them
      // in the order they were CHECKED. That one order drives the warrant number, the system
      // id and so the printed number range.
      const records = sortTrWorkFileRecords(
        (this.selectedItems || [])
          .filter((rec) => !this.excludedSelectedKeys.has(`${rec.taxYear}-${rec.taxId}`)),
        this.gridSortBy,
      );
      records.forEach((record, index) => {
        taxInquiryItems.push({
          taxYear: record.taxYear,
          taxId: record.taxId,
          baseId: record.baseId,
          warrantNumber: this.editedItem.warrantNumber + index,
          sherifFee: item.sherifFee,
          treasureFee: item.treasureFee,
          sherifFeeAmount: warrantAmountUtils.toNumber(item.sherifFeeAmount),
          treasureFeeAmount: warrantAmountUtils.toNumber(item.treasureFeeAmount),
          taxInquiryTransaction: record.taxInquiryTransaction,
          systemId: (warrantAmountUtils.toNumber(this.editedItem.systemId) + index),
          aliasNumber: 1,
          issueDate: toIsoDate(new Date()),
          penaltyDate: (this.editedItem.penaltyDate),
          totalDue: record.totalDue,
          totalFee: record.totalFee,
          totalTax: record.totalTax,
          propertyOrParcelId: record.propertyOrParcelId,
        });
      });
      return taxInquiryItems;
    },

    // The beginning number shown in the dialog was fetched when the dialog opened. A list
    // action run in pages - or a second clerk - can have consumed that number in the
    // meantime (Tulsa 9/15/2026: page 2 was submitted a minute after page 1 and reused all
    // 26 of its numbers). Re-read it here, at submit time, so the batch is numbered from
    // whatever is actually free rather than from a stale snapshot.
    async refreshStartingNumbers() {
      const [maxWarrantNo, maxSystemId] = await Promise.all([
        this.loadLastWarrantNo(),
        this.loadLastSystemID(),
      ]);
      // Both actions swallow their failure and return {} - numbering off a value we could
      // not confirm is exactly what created the duplicates, so refuse to submit instead.
      if (!Number.isFinite(maxWarrantNo) || !Number.isFinite(maxSystemId)) {
        return false;
      }
      if (!this.applyBeginningWarrantNumber(maxWarrantNo + 1)) return false;
      this.editedItem.systemId = maxSystemId + 1;
      return true;
    },

    async upsertTransaction(item) {
      // CRUDDialog closes as soon as it emits upsertItem, so these have to be flash
      // messages - the dialog's own errorMessage line is gone by the time one would show.
      if (!this.currentWarrantTaxYear) {
        this.flashError('Could not determine the current tax year for the warrant number - nothing was saved. Please check Tax Settings and try again.');
        return;
      }
      if (!await this.refreshStartingNumbers()) {
        this.flashError('Could not confirm the next free warrant number - nothing was saved. Please try again.');
        return;
      }
      const updatedItem = this.preProcessForUpsert(item);
      if (updatedItem.length === 0) {
        this.flashError('Every selected record carries a status code excluded from Personal Tax Warrants - nothing was created.');
        return;
      }
      await this.upsertBulkTaxWarrant({ item: updatedItem, baseCrudKey: this.dialogCrudKey });
      await this.offerToPrintBatch(updatedItem);
    },

    /**
     * Print the batch that was just created, without making the clerk go and find it again.
     * Driven off the warrant number range rather than ids: the bulk mutation returns a
     * write summary, not the saved records, and the numbers are contiguous because
     * preProcessForUpsert hands them out in one run.
     */
    async offerToPrintBatch(createdItems) {
      const numbers = createdItems.map((rec) => rec.warrantNumber).filter(Number.isFinite);
      if (numbers.length === 0) return;
      const fromWarrantNumber = Math.min(...numbers);
      const toWarrantNumber = Math.max(...numbers);
      // eslint-disable-next-line no-alert
      if (!window.confirm(`${numbers.length} warrant(s) created (#${fromWarrantNumber} - #${toWarrantNumber}).\n\nPrint the warrant forms and letters for this batch now?`)) {
        return;
      }
      const { jwt } = await this.reAuth();
      const query = urlEncodeObject({ fromWarrantNumber, toWarrantNumber, token: jwt });
      // Two tabs, one per document - the same two reports the Tax Warrants screen opens.
      window.open(`${backendRest.defaults.baseURL}/tax/personal-taxwarrant-report?${query}`);
      window.open(`${backendRest.defaults.baseURL}/tax/personal-taxwarrant-letter-report?${query}`);
    },

  },
};
</script>

<style scoped>
.custom-red-text {
  color: red;
  font-weight: bold;
}
</style>
